var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":"houseApproved","rules":"required","tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var errors = ref.errors;
return [_c('HomecheckOptions',{attrs:{"invalid":failed,"options":_vm.approvedByHouseOwnerOptions,"value":_vm.value,"name":"houseApproved"},on:{"change":function($event){return _vm.$emit('input', $event)}}}),_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(errors[0]))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }